import i18n from 'i18n/i18n';

export const MAX_RETRIES = 3;
export const MAX_BATCH_SIZE = 4;
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50];
export const EMPTY_TABLE_DATA = {
    data: [],
    filteredData: [],
    searchText: '',
    activeTab: '',
    currentPage: 1,
};
export const SELECT_ALL_BOTS = () => i18n.t('go-personal-bot-selector-select-all');

// Installation-related constants
export const STORAGE_KEY = 'defaultSelectedFilter';
export const DEFAULT_GROUP_INDEX = 2;

export const NO_GROUP_ID = -1;
export const ALL_GROUPS_ID = 0;
export const INSTALLATION_SELECT = 'installation-select';
export const TAGS_SELECT = 'getTags';
export const TAGS_KEY = 'tags';
export const GROUP_NONE_ID = -2;
